export default class ClassList {

  constructor(component, tokens = []) {
    this.component = component
    this.tokens = tokens
  }

  add(token, prepend = false) {
    if (this.contains(token))
      return

    if (prepend === true) {
      this.tokens.unshift(token)
    } else {
      this.tokens.push(token)
    }
  }

  contains(token) {
    return this.tokens.indexOf(token) !== -1
  }

  item(index) {
    return this.tokens[index] || null
  }

  remove(token) {
    const i = this.tokens.indexOf(token)
     if (i === -1)
       return
    this.tokens.splice(i, 1)
  }

  toggle(token) {
    if (this.contains(token)) {
      this.remove(token)
    } else {
      this.add(token)
    }
  }

  update(tokenMap) {
    for (let token in tokenMap) {
      if (tokenMap[token]) {
        this.add(token)
      } else {
        this.remove(token)
      }
    }

    let className = this.toString()
    if (className != this.component.state.className) {
      this.component.setState({className})
    }
  }

  toString() {
    return this.tokens.join(' ')
  }
}
